import React, { useState, useEffect, useRef, useCallback, useContext, memo } from 'react';
import { IoCloseSharp, IoSendSharp } from 'react-icons/io5';
import { RiImageAddLine } from 'react-icons/ri';
import { Spinner } from 'reactstrap';
import ProfileAvatar from '../common/ProfileAvatar';
import { AddCommentApi } from '../../constants/API';
import { authorize } from '../../shared/authorize';
import "../feeds/comments/commentsection.css"
import axios from 'axios';
import { ShimmerThumbnail } from "react-shimmer-effects";
import "../course-details/course-content-details/listShimmer.css";
import { Language } from '../../App';
import { useCheckSubscriptionPermission } from '../../hooks/useCheckSubscriptionPermission';

const AddComment = ({setParentId, postId, replyId, comment, setComment, selectedImage, setSelectedImage, commentLoading, replyingTo, setReplyingTo,handleGetComments, parentId, handleGetReplies }) => {
  const [image, setImage] = useState(null);
  const [loading,setLoading] = useState(false)
  const textareaRef = useRef(null);
    const { lang } = useContext(Language);
    const checkPermission = useCheckSubscriptionPermission('post_comment');

    const userData = localStorage.getItem("SignupData");
    const user = userData ? JSON.parse(userData) : null;
    const selfImage = user?.data?.image;

  // Handle image upload click
  const handleImageClick = () => {
    document.getElementById('file-input').click();  // Trigger the hidden file input
  };

  // Focus on the textarea when replying to a comment
  useEffect(() => {
    if (replyingTo && textareaRef.current) {
      textareaRef.current.focus();
    }
  }, [replyingTo]);

  // Handle image change
  const handleImageChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      setImage(file)
      const reader = new FileReader();
      reader.onloadend = () => {
        setSelectedImage(reader.result);  // Set the image preview
      };
      reader.readAsDataURL(file);  // Read the file as data URL
    }
  };

  // Handle comment text change
  const handleCommentChange = (event) => {
    setComment(event.target.value);

    if (textareaRef.current) {
      textareaRef.current.style.height = "auto"; // Reset height
      const lineHeight = 20; // Approximate height of one line in pixels
      const maxLines = 4;
      const newHeight = Math.min(textareaRef.current.scrollHeight, lineHeight * maxLines);
      textareaRef.current.style.height = `${newHeight}px`;
    }
  };

  // Handle removing the image preview
  const handleRemoveImage = () => {
    setImage(null);
    setSelectedImage(null);
  };

  const handleCancelReply = () => {
    setReplyingTo("");
    setParentId("");
  };

  const handleKeyDown = (event) => {
    if (event.key === "Backspace" && comment === "" && replyingTo) {
      event.preventDefault();
      handleCancelReply();
    }
  };

  // Handle comment submission
  const handleSubmit = () => {
    if (!comment.trim() && !image) return; // Prevent empty submission
    if (image) {
    }

    // Reset the form after submission
    handleAddComment();
  };

  const handleAddComment = useCallback(async () => {
    // Check permission for posting comment
    if (!checkPermission()) {
      return; // Toast "Buy a Subscription!" already shown
    }

    if (loading) return;

    setLoading(true);

    try {
      // Create FormData to send the image properly
      const formData = new FormData();
      formData.append("comment", comment);
      formData.append("post_id", postId);

      if (image) {
        formData.append("image", image);
      }

      if (parentId) {
        formData.append("parent", parentId);
      }
      if (replyId) {
        formData.append("mentions", replyId)
      }

      const response = await axios.post(
        `${AddCommentApi}`,
        formData,
        {
          headers: {
            ...authorize().headers, // Merge existing headers
            "Content-Type": "multipart/form-data", // Ensure multipart data
          },
        }
      );

      if (response.data.status) {
        setComment("");
        handleGetComments();
        parentId && handleGetReplies(parentId);
        setImage(null);
        setReplyingTo('');
        setSelectedImage(null);
        setParentId('');
      }
    } catch (error) {
      console.error("Error uploading comment:", error);
    } finally {
      setLoading(false);
    }
  }, [comment, postId, image, parentId]);

  const canSubmit = (comment.trim() || image) && !loading;

  return (
    <>
    {commentLoading ?
    <div className="d-flex align-items-center justify-content-between p-2 custom_list_shimmer">
      <div className="d-flex align-items-center gap-3 custom_list_shimmer">
        <ShimmerThumbnail height={30} width={40} rounded />
        <ShimmerThumbnail height={30} width={160} rounded />
      </div>
      <ShimmerThumbnail height={30} width={70} rounded />
    </div>
    :

      <div className="mr-add-comment">
        <style>{`
          .mr-add-comment {
            padding: 10px 12px 12px;
            border-top: 1px solid #F1F5F9;
            background: #FFFFFF;
          }
          .mr-ac-reply-chip {
            display: inline-flex;
            align-items: center;
            gap: 6px;
            padding: 4px 8px 4px 12px;
            border-radius: 999px;
            background: #E8FBFF;
            border: 1px solid #BCEEFA;
            color: #00838F;
            font-size: 12px;
            font-weight: 600;
            margin-bottom: 8px;
          }
          .mr-ac-reply-chip button {
            width: 18px;
            height: 18px;
            border-radius: 50%;
            border: none;
            background: rgba(0, 186, 218, 0.15);
            color: #00838F;
            display: flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;
            flex-shrink: 0;
            transition: all 0.15s ease;
          }
          .mr-ac-reply-chip button:hover {
            background: #00BADA;
            color: #FFFFFF;
          }
          .mr-ac-image-preview {
            position: relative;
            display: inline-block;
            margin-bottom: 8px;
          }
          .mr-ac-image-preview img {
            width: 64px;
            height: 64px;
            object-fit: cover;
            border-radius: 14px;
            border: 1px solid #EEF2F6;
          }
          .mr-ac-image-remove {
            position: absolute;
            top: -6px;
            right: -6px;
            width: 20px;
            height: 20px;
            border-radius: 50%;
            border: 2px solid #FFFFFF;
            background: #0F172A;
            color: #FFFFFF;
            display: flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;
          }
          .mr-ac-row {
            display: flex;
            align-items: flex-end;
            gap: 8px;
          }
          .mr-ac-icon-btn {
            width: 38px;
            height: 38px;
            border-radius: 50%;
            border: 1px solid #EEF2F6;
            background: #F8FAFC;
            color: #64748B;
            display: flex;
            align-items: center;
            justify-content: center;
            flex-shrink: 0;
            cursor: pointer;
            transition: all 0.18s ease;
          }
          .mr-ac-icon-btn:hover {
            background: #E8FBFF;
            color: #00BADA;
            transform: scale(1.06);
          }
          .mr-ac-field {
            flex: 1 1 auto;
            display: flex;
            align-items: center;
            min-height: 42px;
            padding: 8px 16px;
            border-radius: 999px;
            background: #F8FAFC;
            border: 1px solid #EEF2F6;
            box-shadow: none;
            transition: all 0.2s ease;
          }
          .mr-ac-field:focus-within {
            background: #FFFFFF;
            border-color: #00BADA;
            box-shadow: 0 0 0 3px rgba(0, 186, 218, 0.12);
          }
          .mr-ac-textarea {
            border: none;
            background: transparent;
            resize: none;
            width: 100%;
            font-size: 13.5px;
            color: #0F172A;
            outline: none;
            box-shadow: none !important;
            padding: 0;
          }
          .mr-ac-textarea::placeholder {
            color: #94A3B8;
          }
          .mr-ac-send-btn {
            width: 38px;
            height: 38px;
            border-radius: 50%;
            border: none;
            background: #00BADA;
            color: #FFFFFF;
            display: flex;
            align-items: center;
            justify-content: center;
            flex-shrink: 0;
            cursor: pointer;
            box-shadow: 0 4px 12px rgba(0, 186, 218, 0.3);
            transition: all 0.18s ease;
          }
          .mr-ac-send-btn:hover:not(:disabled) {
            background: #00A3BF;
            transform: translateY(-1px) scale(1.04);
          }
          .mr-ac-send-btn:disabled {
            background: #E2E8F0;
            color: #94A3B8;
            box-shadow: none;
            cursor: not-allowed;
          }
          @media (max-width: 500px) {
            .mr-ac-container {
              padding: 6px 8px 6px !important;
            }
            .mr-ac-field {
              min-height: 36px !important;
              padding: 5px 12px !important;
            }
            .mr-ac-textarea {
              font-size: 12.5px !important;
            }
            .mr-ac-icon-btn,
            .mr-ac-send-btn {
              width: 32px !important;
              height: 32px !important;
            }
          }
        `}</style>

        {replyingTo && (
          <div className="mr-ac-reply-chip">
            <span>{lang?.reply_to} <strong>{replyingTo}</strong></span>
            <button type="button" onClick={handleCancelReply} aria-label="Cancel reply">
              <IoCloseSharp size={12} />
            </button>
          </div>
        )}

        {selectedImage && (
          <div className="mr-ac-image-preview">
            <img src={selectedImage} alt="preview" />
            <button
              type="button"
              className="mr-ac-image-remove"
              onClick={handleRemoveImage}
              aria-label="Remove image"
            >
              <IoCloseSharp size={12} />
            </button>
          </div>
        )}

        <div className="mr-ac-row">
          <ProfileAvatar src={selfImage} size={38} variant="cyan" alt="You" className="flex-shrink-0 d-none d-sm-block" />

          {!replyingTo && (
            <button
              type="button"
              className="mr-ac-icon-btn"
              onClick={handleImageClick}
              aria-label="Attach image"
            >
              <RiImageAddLine size={18} />
            </button>
          )}

          {/* Hidden file input for selecting an image */}
          <input
            type="file"
            id="file-input"
            style={{ display: "none" }}
            onChange={handleImageChange}
            accept="image/*"
          />

          {/* Text input for the comment */}
          <div className="mr-ac-field">
            <textarea
              value={comment}
              onChange={handleCommentChange}
              onKeyDown={handleKeyDown}
              placeholder={lang?.add_comment}
              className="mr-ac-textarea scroll-hide"
              ref={textareaRef}
              rows={1}
            />
          </div>

          <button
            type="button"
            className="mr-ac-send-btn"
            disabled={!canSubmit}
            onClick={handleSubmit}
            aria-label={lang?.publish || "Publish"}
          >
            {loading ? <Spinner size="sm" style={{ width: "16px", height: "16px" }} /> : <IoSendSharp size={16} />}
          </button>
        </div>
      </div>
    }
    </>
  );
};

export default memo(AddComment);
